import { render, staticRenderFns } from "./push-redbook.vue?vue&type=template&id=1a938687&scoped=true&"
import script from "./push-redbook.vue?vue&type=script&lang=js&"
export * from "./push-redbook.vue?vue&type=script&lang=js&"
import style0 from "./push-redbook.vue?vue&type=style&index=0&id=1a938687&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a938687",
  null
  
)

export default component.exports